// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__adelaila_b732fd', '__adelaila_Fallback_b732fd'"},"className":"__className_b732fd","variable":"__variable_b732fd"};